var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisitorManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5H5V8H6.5V5Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5H5V12.5H6.5V9.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H9.5V8H11V5Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5H9.5V12.5H11V9.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14H5V17H6.5V14Z",
    fill: "#030712"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H9.5V17H11V14Z",
    fill: "#030712"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.25H12.5C11.25 19.25 10.25 20.26 10.25 21.5V23H11.75V21.5C11.75 21.09 12.09 20.75 12.5 20.75H17C17.41 20.75 17.75 21.09 17.75 21.5V23H19.25V21.5C19.25 20.26 18.24 19.25 17 19.25Z",
    fill: "#030712"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.5C11.75 17.16 13.09 18.5 14.75 18.5C16.41 18.5 17.75 17.16 17.75 15.5C17.75 13.84 16.41 12.5 14.75 12.5C13.09 12.5 11.75 13.84 11.75 15.5ZM16.25 15.5C16.25 16.33 15.58 17 14.75 17C13.92 17 13.25 16.33 13.25 15.5C13.25 14.67 13.93 14 14.75 14C15.57 14 16.25 14.68 16.25 15.5Z",
    fill: "#030712"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.5C21.5 13.84 20.16 12.5 18.5 12.5V14C19.32 14 20 14.67 20 15.5C20 16.33 19.32 17 18.5 17V18.5C20.16 18.5 21.5 17.16 21.5 15.5Z",
    fill: "#030712"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19.25H20V20.75H20.75C21.16 20.75 21.5 21.09 21.5 21.5V23H23V21.5C23 20.26 21.99 19.25 20.75 19.25Z",
    fill: "#030712"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H14V11H15.5V2C15.5 1.6 15.34 1.22 15.06 0.94C14.78 0.66 14.4 0.5 14 0.5H2C1.6 0.5 1.22 0.66 0.94 0.94C0.66 1.22 0.5 1.6 0.5 2V21.5H8.75V20H2V2Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisitorManagment);
export default __webpack_public_path__ + "static/media/ic-visitor-managment.27350200ba5883141cac05a39ae14e49.svg";
export { ForwardRef as ReactComponent };